import Script from 'next/script';

import { LIMY_DRUSHIM_TOKEN, LIMY_YAD2_TOKEN } from '../consts';

type Props = {
  origin: 'yad2' | 'drushim';
};

export const LimyAiScript = ({ origin }: Props) => {
  const token = origin === 'yad2' ? LIMY_YAD2_TOKEN : LIMY_DRUSHIM_TOKEN;

  return (
    <Script
      id="limy-ai-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
        (function(l,i,m,y,g,e,o){
          l[m] = l[m] || function () {
            (l[m].q = l[m].q || []).push(arguments)
          };
          e = i.createElement(y);
          e.async = 1;
          e.id = 'limy-analytics';
          e.src = "https://sdk.getlimy.ai/p/limy-analytics.min.js";
          e.setAttribute(m, g);
          o = i.getElementsByTagName(y)[0];
          o.parentNode.insertBefore(e, o);
        })(window, document, "limy", "script", "${token}");`,
      }}
    />
  );
};
